/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DateRangeInput = {
    maxDate: string;
    minDate: string;
};
export type HeatmapQueryVariables = {
    dateRange: DateRangeInput;
    timeZone: string;
    calendarIds: Array<string>;
};
export type HeatmapQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly fetchHeatmapErrorable: {
                            readonly __typename: "GraphEntityError";
                            readonly message: string | null;
                        } | {
                            readonly __typename: "HeatmapResult";
                            readonly crawledCalendarIds: ReadonlyArray<string>;
                            readonly uncrawledCalendarIds: ReadonlyArray<string>;
                            readonly busyHours: ReadonlyArray<{
                                readonly startTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                                readonly endTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                            }>;
                            readonly holdHours: ReadonlyArray<{
                                readonly startTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                                readonly endTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                            }>;
                            readonly meetingHours: ReadonlyArray<{
                                readonly startTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                                readonly endTime: {
                                    readonly dateOrDateTime: string;
                                } | null;
                            }>;
                        } | {
                            /*This will never be '%other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        };
                    } | null;
                } | null> | null;
            };
        } | null;
    };
};
export type HeatmapQuery = {
    readonly response: HeatmapQueryResponse;
    readonly variables: HeatmapQueryVariables;
};



/*
query HeatmapQuery(
  $dateRange: DateRangeInput!
  $timeZone: String!
  $calendarIds: [String!]!
) {
  viewer {
    user {
      orgs(first: 1000000) {
        edges {
          node {
            fetchHeatmapErrorable(dateRange: $dateRange, timeZone: $timeZone, calendarIds: $calendarIds) {
              __typename
              ... on GraphEntityError {
                message
              }
              ... on HeatmapResult {
                crawledCalendarIds
                uncrawledCalendarIds
                busyHours {
                  startTime {
                    dateOrDateTime
                  }
                  endTime {
                    dateOrDateTime
                  }
                  id
                }
                holdHours {
                  startTime {
                    dateOrDateTime
                  }
                  endTime {
                    dateOrDateTime
                  }
                  id
                }
                meetingHours {
                  startTime {
                    dateOrDateTime
                  }
                  endTime {
                    dateOrDateTime
                  }
                  id
                }
              }
            }
            id
          }
        }
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dateRange"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v4 = [
        {
            "kind": "Variable",
            "name": "calendarIds",
            "variableName": "calendarIds"
        } as any,
        {
            "kind": "Variable",
            "name": "dateRange",
            "variableName": "dateRange"
        } as any,
        {
            "kind": "Variable",
            "name": "timeZone",
            "variableName": "timeZone"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "crawledCalendarIds",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uncrawledCalendarIds",
        "storageKey": null
    } as any, v9 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any
    ], v10 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v9 /*: any*/),
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v9 /*: any*/),
        "storageKey": null
    } as any, v12 = [
        (v10 /*: any*/),
        (v11 /*: any*/)
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v14 = [
        (v10 /*: any*/),
        (v11 /*: any*/),
        (v13 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "HeatmapQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": (v4 /*: any*/),
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "fetchHeatmapErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "busyHours",
                                                                            "plural": true,
                                                                            "selections": (v12 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "holdHours",
                                                                            "plural": true,
                                                                            "selections": (v12 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "meetingHours",
                                                                            "plural": true,
                                                                            "selections": (v12 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "HeatmapResult",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "HeatmapQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": (v4 /*: any*/),
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "fetchHeatmapErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "busyHours",
                                                                            "plural": true,
                                                                            "selections": (v14 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "holdHours",
                                                                            "plural": true,
                                                                            "selections": (v14 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "meetingHours",
                                                                            "plural": true,
                                                                            "selections": (v14 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "HeatmapResult",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v13 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v13 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v13 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "447450b48910fd16d4d44064a92fcac8",
            "id": null,
            "metadata": {},
            "name": "HeatmapQuery",
            "operationKind": "query",
            "text": "query HeatmapQuery(\n  $dateRange: DateRangeInput!\n  $timeZone: String!\n  $calendarIds: [String!]!\n) {\n  viewer {\n    user {\n      orgs(first: 1000000) {\n        edges {\n          node {\n            fetchHeatmapErrorable(dateRange: $dateRange, timeZone: $timeZone, calendarIds: $calendarIds) {\n              __typename\n              ... on GraphEntityError {\n                message\n              }\n              ... on HeatmapResult {\n                crawledCalendarIds\n                uncrawledCalendarIds\n                busyHours {\n                  startTime {\n                    dateOrDateTime\n                  }\n                  endTime {\n                    dateOrDateTime\n                  }\n                  id\n                }\n                holdHours {\n                  startTime {\n                    dateOrDateTime\n                  }\n                  endTime {\n                    dateOrDateTime\n                  }\n                  id\n                }\n                meetingHours {\n                  startTime {\n                    dateOrDateTime\n                  }\n                  endTime {\n                    dateOrDateTime\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f55a027cd029fff2cff165e62072b89e';
export default node;
